// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"60d63971","259":"b32ef760","402":"61e9caf2","668":"b3fe0a2d","758":"85cce3e7","759":"ff14b743"}[chunkId] + ".chunk.js";
};